import React from "react"
import {
  Box, Divider, Flex, Text,
} from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import { useForms } from "queries/forms"
import { getFormsGroupedByType } from "utilities/forms"
import { MERGE_TAGS, NAME_FIELD_TAGS } from "utilities/enums"
import { SUBJECT_LINE_MERGE_TAGS } from "../subjectLineTags"
import MergeFieldPill from "./MergeFieldPill"

type MergeTagOption = { id: string; label: string }

type Props = {
  event: DioboxEvent
  onInsert: (tagId: string) => void
  onInsertStart?: () => void
  draggable?: boolean
  guestFieldsOnly?: boolean
  subjectLineOnly?: boolean
}

const MergeFieldInsertPanel = ({
  event,
  onInsert,
  onInsertStart,
  draggable = false,
  guestFieldsOnly = false,
  subjectLineOnly = false,
}: Props) => {
  const guestTags: MergeTagOption[] = subjectLineOnly
    ? SUBJECT_LINE_MERGE_TAGS
    : MERGE_TAGS
  const loadFormOptions = !guestFieldsOnly && !subjectLineOnly
  const { data } = useForms(event.id, { enabled: loadFormOptions })
  const allFormOptions = loadFormOptions
    ? getFormsGroupedByType(data?.data ?? [], event).flatMap(({ options }) => options)
    : []

  return (
    <Box p={4}>
      <Text fontSize="sm" fontWeight="semibold" color="gray.600" mb={2}>Guest Fields</Text>
      <Flex flexWrap="wrap" gap={2}>
        {guestTags.map(({ id, label }) => (
          <MergeFieldPill
            key={id}
            variant={
              guestFieldsOnly || subjectLineOnly || NAME_FIELD_TAGS.includes(id)
                ? "selectable"
                : "locked"
            }
            tagId={id}
            label={label}
            draggable={draggable}
            onInsert={onInsert}
            onInsertStart={onInsertStart}
          />
        ))}
      </Flex>

      {allFormOptions.length > 0 && (
        <>
          <Divider my={3} />
          <Text fontSize="sm" fontWeight="semibold" color="gray.600" mb={2}>Form Links</Text>
          <Flex flexWrap="wrap" gap={2}>
            {allFormOptions.map(({ label: optionLabel, value, disabled }) => (
              <MergeFieldPill
                key={value}
                variant="selectable"
                tagId={`FORM_${value}`}
                label={optionLabel}
                disabled={disabled}
                draggable={draggable}
                onInsert={onInsert}
                onInsertStart={onInsertStart}
              />
            ))}
          </Flex>
        </>
      )}
    </Box>
  )
}

export default MergeFieldInsertPanel
